export const questionTypes = {
  QUESTION_TYPE_STAR: 0,
  QUESTION_TYPE_RADIO: 2,
  QUESTION_TYPE_TEXT: 1,
  QUESTIONS_COUNT: 7,
};